import { Outlet } from 'react-router-dom';

import { AdminSidebar } from '@/components/admin/AdminSidebar';

/**
 * Desktop layout for the admin app. The sidebar is fixed-width on the left,
 * the main pane scrolls. Designed for screens ≥ 1024 px wide; on smaller
 * screens it gracefully stacks (sidebar collapses).
 */
export function AdminLayout() {
  return (
    <div className="flex min-h-[100dvh] bg-cream text-ink dark:bg-d-bg dark:text-d-ink">
      <AdminSidebar />
      <main className="flex-1 overflow-x-auto p-9">
        <Outlet />
      </main>
    </div>
  );
}
